import Axios from 'axios';
import { authTokenStorageKey } from '../reducers/authStatus';

Axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
Axios.interceptors.request.use(async (config) => {
  if (config.url) {
    const slash = config.url.lastIndexOf('/');
    const url = slash >= 0 ? config.url.substring(0, slash) : config.url;
    if (!url.startsWith('/api/auth/')) {
      let token = localStorage.getItem(authTokenStorageKey);
      if (token) {
        if (!token.startsWith('Bearer ')) token = `Bearer ${token}`;
        config.headers['Authorization'] = token;
      }
    }
  }
  return config;
});

